import React from "react";
import {mdiMapMarkerPath, mdiPhone, mdiTruck} from "@mdi/js";
import Icon from "@mdi/react";
import {Link} from "react-router-dom";
import {Trip} from "../types/Trip";
import {useManageContext} from "../App";

export default function ActiveTripHeader({trip}: { trip: Trip | null }) {

    const {isDarkMode} = useManageContext();

    if (!trip) {
        return null;
    }

    return (
        <div className="bg-primary-container pb-3">
            <div className="d-flex px-4 pt-4 justify-content-between align-items-center">
                <div>
                    <div className="d-flex align-items-center mb-1">
                        <Icon className="text-primary" path={mdiMapMarkerPath} size={1.3}/>
                        <h3 className="mb-0 fw-bold ms-1">{trip.TripNo}</h3>
                    </div>
                    <div className="d-flex align-items-center ms-1">
                        <Icon className="text-primary" path={mdiTruck} size={.9}/>
                        <p className="mb-0 ms-1 fw-light">{trip.TruckTrailerNo}</p>
                    </div>
                </div>
                <div className="text-end">
                    <h6>{trip.TripCompany}</h6>
                    <Link to={'tel:' + trip.TransportManagerPhone} className="btn btn-sm btn-secondary d-flex align-items-center">
                        <Icon className="text-primary" path={mdiPhone} size={.7}/>
                        <span className="mx-1 text-primary">{trip.TransportManager}</span>
                    </Link>
                </div>
            </div>
            {trip.TripDescriptionHtml !== ''
                ? <div dangerouslySetInnerHTML={{
                    __html: trip.TripDescriptionHtml,
                }} className={(isDarkMode ? 'bg-dark' : 'bg-light') + ' p-4 mx-4 mt-3 rounded'}></div>
                : <div className="pt-4"></div>}
        </div>
    );
}